var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideosSlide7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,0H4.5C2.019,0,0,2.019,0,4.5V13.5c0,2.481,2.019,4.5,4.5,4.5h15c2.481,0,4.5-2.019,4.5-4.5V4.5c0-2.481-2.019-4.5-4.5-4.5Zm3.5,13.5c0,1.93-1.57,3.5-3.5,3.5H4.5c-1.93,0-3.5-1.57-3.5-3.5V4.5c0-1.93,1.57-3.5,3.5-3.5h15c1.93,0,3.5,1.57,3.5,3.5V13.5Zm-7.335-5.931l-5.207-2.851c-1.04-.643-2.499,.203-2.458,1.426v5.711c0,.592,.306,1.123,.818,1.42,.509,.296,1.122,.301,1.632,.011l5.222-2.861c1.094-.58,1.092-2.278-.008-2.857Zm-.48,1.984l-5.222,2.86c-.563,.2-.857,.032-.962-.558V6.145c.065-.599,.513-.763,.969-.553l5.207,2.851c.46,.382,.46,.73,.008,1.112Zm8.316,11.946H9.929c-.224-.86-1-1.5-1.929-1.5s-1.705,.64-1.929,1.5H.5c-.276,0-.5,.224-.5,.5s.224,.5,.5,.5H6.071c.224,.86,1,1.5,1.929,1.5s1.705-.64,1.929-1.5h13.571c.276,0,.5-.224,.5-.5s-.224-.5-.5-.5Zm-15.5,1.5c-.551,0-1-.448-1-1s.449-1,1-1,1,.448,1,1-.449,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosSlide7);
export default __webpack_public_path__ + "static/media/videos-slide-7.f5efd558c479a931ca878fe53995157f.svg";
export { ForwardRef as ReactComponent };